import SiteCard from '@/components/base/SiteCard';
import SectionHeading from '@/components/base/SectionHeading';
import HeroBanner from '@/pages/home/components/HeroBanner';
import CategoryShortcuts from '@/pages/home/components/CategoryShortcuts';
import TopicShowcase from '@/pages/home/components/TopicShowcase';
import LatestList from '@/pages/home/components/LatestList';
import IntroSection from '@/pages/home/components/IntroSection';
import { useSeo } from '@/hooks/useSeo';
import { getHotSites } from '@/utils/nav';

export default function Home() {
  useSeo({
    title: '蓝导航-首页-便捷的综合导航平台',
    description:
      '蓝导航为用户提供丰富实用的网页导航入口，涵盖新闻、视频、购物、社交等多领域，助您快速访问所需网站。',
    keywords: '蓝导航,综合导航,网站导航,快捷入口,在线导航,实用导航,导航平台',
  });

  const hotSites = getHotSites(6);

  return (
    <div className="w-full">
      <HeroBanner />

      <CategoryShortcuts />

      <section className="mt-10">
        <SectionHeading
          eyebrow="人气榜单"
          title="热门导航"
          description="根据访问热度整理的网站入口，覆盖各领域的常用站点。"
          action={{ to: '/category/news', label: '浏览全部分类' }}
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {hotSites.map((site) => (
            <SiteCard key={site.id} site={site} />
          ))}
        </div>
      </section>

      <TopicShowcase />

      <LatestList />

      <IntroSection />
    </div>
  );
}